export const Field = ({ id, label, error, as = "input", className = "", children, ...rest }) => {
  const Tag = as;
  return (
    <div className={className}>
      <label htmlFor={id} className="mb-1.5 block text-sm font-semibold text-cs-navy">
        {label}
      </label>
      <Tag
        id={id}
        name={id}
        data-testid={`quote-${id}-input`}
        aria-invalid={!!error}
        aria-describedby={error ? `${id}-error` : undefined}
        className={`field ${error ? "field-error" : ""}`}
        {...rest}
      >
        {children}
      </Tag>
      {error && (
        <p id={`${id}-error`} data-testid={`quote-${id}-error`} className="mt-1.5 text-[13px] font-medium text-red-600">
          {error}
        </p>
      )}
    </div>
  );
};
